export enum TableFilter {
  SELECT_SINGLE = 'select-single',
  SEARCH = 'search',
  DATE = 'date',
  DATE_RANGE = 'date-range',
  DATE_TIME = 'date-time',
  CHIP_GROUP = 'chip-group',
  TEXT_FIELD = 'textfield',
  NUMBER_RANGE = 'number-range',
  CHECKBOX = 'checkbox',

  // // 'special' filters that require type aaheads that hit the api and load more
  BROKERAGE_TYPEAHEAD = 'BrokerageTypeaheadFilter',
  OFFERING_TYPEAHEAD = 'OfferingTypeaheadFilter',
  BUSINESS_CLASS_TYPEAHEAD = 'BusinessClassTypeaheadFilter',
  PRODUCT_LABEL_TYPEAHEAD = 'ProductLabelTypeaheadFilter',
  WRITING_COMPANY_TYPEAHEAD = 'WritingCompanyTypeaheadFilter',
  UNDERWRITER_TYPEAHEAD_FILTER = 'UnderwriterTypeaheadFilter',
  BROKERAGE_PRODUCER_TYPEAHEAD = 'BrokerageProducerTypeaheadFilter',
  JURISDICTION_TYPEAHEAD = 'JurisdictionTypeaheadFilter',
  TRANSACTION_TYPE_TYPEAHEAD = 'QuoteTypeTypeaheadFilter',
  QUOTE_STATUS_TYPEAHEAD = 'QuoteStatusTypeaheadFilter',
  POLICY_STATUS_FILTER = 'PolicyStatusFilter',
  QUOTE_ORIGIN_TYPEAHEAD = 'QuoteOriginTypeaheadFilter',
  REPORTING_QUOTE_SOURCE_TYPEAHEAD = 'ReportingQuoteSourceTypeaheadFilter',
  UNDERWRITING_ACTIVITY_TYPE_TYPEAHEAD = 'UnderwritingActivityTypeTypeaheadFilter',

  INSURANCE_LINE_TYPEAHEAD = 'InsuranceLineTypeaheadFilter',
  LINE_OF_BUSINESS_TYPEAHEAD = 'LineOfBusinessTypeaheadFilter',
  COVERAGE_CATEGORY_TYPEAHEAD = 'CoverageCategoryTypeaheadFilter',
  POST_RATE_DEFAULT_FACTOR_TYPEAHEAD = 'PostRateDefaultFactorTypeTypeaheadFilter',

  // TODO: add others as needed
}
